module.exports = __webpack_public_path__ + "static/img/img_t.060f9cfc.webp";